import { NormalState } from "./NormalState";
var EditMinuteState = /** @class */ (function () {
    function EditMinuteState() {
        this.toString = function () {
            return "Edit Minutes";
        };
    }
    EditMinuteState.prototype.handleMode = function (watch) {
        watch.setState(new NormalState());
    };
    EditMinuteState.prototype.handleIncrease = function (watch) {
        watch.getTimeOffset().minutes += 1;
    };
    return EditMinuteState;
}());
export { EditMinuteState };
